<template>
<div v-if="spinner" class="text-center" >
    <div class="spinner-border text-primary"  style="width: 4rem; height: 4rem;" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
</template>
<script>
export default {
  props: ['spinner'],
  data () 
  {
    return {
        //spinner : false
    }
    
    },
  computed : {
     
  },
   created () 
    {
      
      
    },
  methods: {
   
   
  }
}
</script>

<style scoped>

</style>
